export default __webpack_public_path__ + "static/kiln-3-cec03cc9e28a08fee4953c913b766ff9.jpg";